import {
	gigListingsList,
	gigListingDeactivate,
} from '@/services/jobs/gigListings.service'

export default {
	namespaced: true,
	state: {
		list: {
			meta: {
				pagination: {
					total: 0,
				},
			},
		},
		listStatus: 'pending',
		saveStatus: 'init',
	},
	getters: {
		getList(state)       { return state.list },
		getListStatus(state) { return state.listStatus },
		getSaveStatus(state) { return state.saveStatus },
	},
	mutations: {
		SET_LIST(state, value)        { state.list = value },
		SET_LIST_STATUS(state, value) { state.listStatus = value },
		SET_SAVE_STATUS(state, value) { state.saveStatus = value },
	},
	actions: {
		async fetchList({ commit }, params) {
			commit('SET_LIST_STATUS', 'pending')
			try {
				const { data } = await gigListingsList(params)
				commit('SET_LIST_STATUS', 'init')
				commit('SET_LIST', data)
				return data
			} catch (error) {
				commit('SET_LIST_STATUS', 'init')
				throw error
			}
		},
		async deactivate({ commit }, params) {
			commit('SET_SAVE_STATUS', 'pending')
			try {
				const { data } = await gigListingDeactivate(params)
				commit('SET_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('SET_SAVE_STATUS', 'init')
				throw error
			}
		},
	},
}
